<template>
  <v-row class="mt-5">
    <v-col cols="4">
      <album-list :albums="albums" @select="selectAlbum" @refresh="fetchAll" @create="openCreateDialog" />
    </v-col>
    <v-col cols="8">
      <album-detail @refresh="fetchAll" v-if="selectedAlbum" :album="selectedAlbum" />
      <v-alert v-else type="info">Wähle ein Album zum Ansehen</v-alert>
    </v-col>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title>Create New Album</v-card-title>
        <v-card-text>
          <v-text-field v-model="newTitle" label="Album Name" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="doCreate">Erstellen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from "@/api"
import albumList from "./albumList.vue"
import albumDetail from "./albumDetail.vue"
export default {
  components: { albumList, albumDetail },
  data() {
    return {
      albums: [],
      selectedAlbum: null,
      dialog: false,
      newTitle: "",
    }
  },
  methods: {
    async fetchAll() {
      this.albums = await api.display.fetchAlbums()
    },
    selectAlbum(album) {
      this.selectedAlbum = album
    },
    openCreateDialog() {
      this.dialog = true
    },
    async doCreate() {
      if (!this.newTitle) return
      const alb = await api.display.createAlbum({ title: this.newTitle })
      this.albums.push(alb)
      this.newTitle = ""
      this.dialog = false
    },
  },
  created() {
    this.fetchAll()
  },
}
</script>
